import { useQuery } from '@tanstack/react-query'

import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { ApiErrorResponse } from 'services/types'

import { getRelatedDataAccessRequests } from './getRelatedDataAccessRequests'
import type { GetRelatedDataAccessRequestsResponse, RelatedDataAccessRequest } from './types'

export interface UseRelatedDataAccessRequestsResult {
  relatedRequests: RelatedDataAccessRequest[]
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}

export const useRelatedDataAccessRequests = (groupId: string): UseRelatedDataAccessRequestsResult => {
  const normalizedGroupId = groupId.trim()
  const enabled = normalizedGroupId.length > 0

  const query = useQuery<GetRelatedDataAccessRequestsResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.RelatedRequests(normalizedGroupId),
    queryFn: () => getRelatedDataAccessRequests(normalizedGroupId),
    enabled,
    retry: false
  })

  return {
    relatedRequests: query.data?.data ?? [],
    isLoading: enabled && query.isLoading,
    isError: query.isError,
    isSuccess: enabled && query.isSuccess
  }
}
